import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import ToolTipPopUpModal from './ToolTipPopUpModal.js';

const ToolTipPopUpModalContainer = (props)=>{
    const { useIsPhone  } = MediaQuery;
    const isPhone = useIsPhone();
    return /*#__PURE__*/ React.createElement(ToolTipPopUpModal, swcHelpers.extends({}, props, {
        isPhone: isPhone
    }));
};
var ToolTipPopUpModalContainer$1 = ToolTipPopUpModalContainer;

export { ToolTipPopUpModalContainer, ToolTipPopUpModalContainer$1 as default };
//# sourceMappingURL=ToolTipPopUpModalContainer.js.map
